import React, { type JSX } from "react";
import { createPortal } from "react-dom";
import RenameChatModal from "../RenameChatModal_Component";
import DeleteChatModal from "../DeleteChatModal_Component";
import SearchChatsModal from "../SearchChatsModal_Component";
import type { ChatTarget } from "./ChatList";

interface SidebarModalsProps {
  renameTarget: ChatTarget | null;
  deleteTarget: ChatTarget | null;
  isSearchModalOpen: boolean;
  currentProjectId: string | null;
  onCloseRename: () => void;
  onCloseDelete: () => void;
  onCloseSearch: () => void;
  onStartProject?: () => void;
  onProjectClick?: (projectId: string) => void;
}

/**
 * Modals rendered via portal to avoid CSS transform breaking fixed positioning
 * on mobile.
 */
export default function SidebarModals({
  renameTarget,
  deleteTarget,
  isSearchModalOpen,
  currentProjectId,
  onCloseRename,
  onCloseDelete,
  onCloseSearch,
  onStartProject,
  onProjectClick,
}: SidebarModalsProps): JSX.Element {
  return (
    <>
      {renameTarget &&
        createPortal(
          <RenameChatModal
            isOpen={true}
            onClose={onCloseRename}
            projectId={renameTarget.id}
            currentName={renameTarget.name}
          />,
          document.body
        )}
      {deleteTarget &&
        createPortal(
          <DeleteChatModal
            isOpen={true}
            onClose={onCloseDelete}
            projectId={deleteTarget.id}
            projectName={deleteTarget.name}
            onDeleted={() => {
              const deletedId = deleteTarget.id;
              onCloseDelete();
              if (deletedId === currentProjectId) {
                onStartProject && onStartProject();
              }
            }}
          />,
          document.body
        )}
      {createPortal(
        <SearchChatsModal
          isOpen={isSearchModalOpen}
          onClose={onCloseSearch}
          onSelectProject={(projectId) => {
            onProjectClick && onProjectClick(projectId);
          }}
        />,
        document.body
      )}
    </>
  );
}
